import Footer from "../components/Footer";
import Header from "../components/Header";
import "./Contact.css";

const ContactForm = () => {
  return (
    <div>
      <Header />
      <section className="contact-section">
        <div className="contact-container">
          <div className="contact-heading">
            <h2>Contact Us</h2>
          </div>
          <div className="contact-content">
            <div className="contact-form">
              <div className="contact-form-top">
                <div className="contact-form-con">
                  <span className="contact-send-message">
                    Send us a Message
                  </span>
                  <p>
                    Feel free to get in touch with us. We are available to
                    assist you with any inquiries or questions.
                  </p>
                </div>
              </div>
              <div className="contact-form-bottom">
                <form id="contactForm" className="contactForm" noValidate>
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Name"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Email"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phoneNumber">phone number</label>
                    <input
                      type="text"
                      id="phoneNumber"
                      name="phoneNumber"
                      placeholder="Phone Number"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="message">Message</label>
                    <textarea
                      id="message"
                      name="message"
                      rows={6}
                      placeholder="Your Message"
                      required
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <button type="submit" className="btn-submit">
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default ContactForm;
